<template>
  <div>
    <head>
      <meta charset="utf-8"/>
      <meta content="width=device-width, initial-scale=1.0" name="viewport">
      <meta content="Rental management system by Nouveta LTD" name="description"/>
      <meta content="Kelvin Njuguna" name="author"/>
      <!-- App favicon -->
      <link href="assets/images/favicon.png" rel="shortcut icon">
      <!-- droping file -->
      <link
          href="assets/libs/dropzone/min/dropzone.min.css"
          rel="stylesheet"
          type="text/css"
      />

      <!-- DataTables -->
      <link
          href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css"
          rel="stylesheet"
          type="text/css"
      />
      <link
          href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css"
          rel="stylesheet"
          type="text/css"
      />

      <!-- Bootstrap Css -->
      <link
          href="assets/css/bootstrap.min.css"
          id="bootstrap-style"
          rel="stylesheet"
          type="text/css"
      />
      <!-- Bootstrap select styling -->
      <link
          href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css"
          rel="stylesheet"
      >
      <!-- Icons Css -->
      <link
          href="assets/css/icons.min.css"
          rel="stylesheet"
          type="text/css"
      />
      <!-- App Css-->
      <link
          href="assets/css/app.min.css"
          id="app-style"
          rel="stylesheet"
          type="text/css"
      />
      <!-- custom Css-->
      <link
          href="assets/css/custom.css"
          id="app-style"
          rel="stylesheet"
          type="text/css"
      />

    </head>

    <body @contextmenu.prevent data-sidebar="dark">
    <!-- Begin page -->
    <div id="layout-wrapper">
      <NavigationBar/>

      <!-- ============================================================== -->
      <!-- Start right Content here -->
      <!-- ============================================================== -->
      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">

            <!-- Enhanced Header Section with Purple Theme -->
            <div class="page-header-enhanced">
              <div class="header-content-wrapper">
                <div class="header-left">
                  <h1 class="page-main-title">Bills Receipted</h1>
                  <div class="breadcrumb-container">
                    <i class="bx bx-home-alt"></i>
                    <a @click="gotTo('dashboard')" class="breadcrumb-link">Dashboard</a>
                    <span class="breadcrumb-divider">/</span>
                    <span class="breadcrumb-current">Bills Receipted</span>
                  </div>
                </div>
                <div class="header-right">
                  <div class="header-stat-badge">
                    <span class="stat-number">{{numberFormat(summary.count || 0)}}</span>
                    <span class="stat-text">TOTAL RECEIPTS</span>
                  </div>
                  <div class="header-stat-badge primary">
                    <span class="stat-number">{{formatPrice(summary.total || 0)}}</span>
                    <span class="stat-text">TOTAL COLLECTED</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Summary Statistics Cards -->
            <div class="row summary-cards-row">
              <div class="col-lg-3 col-md-6">
                <div class="summary-card purple-gradient">
                  <div class="card-icon-box">
                    <i class="bx bx-receipt"></i>
                  </div>
                  <div class="card-content">
                    <h3 class="card-value">{{numberFormat(filteredBillDetails.length || 0)}}</h3>
                    <p class="card-label">DISPLAYED RECEIPTS</p>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-6">
                <div class="summary-card green-gradient">
                  <div class="card-icon-box">
                    <i class="bx bx-money"></i>
                  </div>
                  <div class="card-content">
                    <h3 class="card-value">{{formatPrice(calculateTotal('receiptAmount'))}}</h3>
                    <p class="card-label">DISPLAYED COLLECTED</p>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-6">
                <div class="summary-card cyan-gradient">
                  <div class="card-icon-box">
                    <i class="bx bx-check-circle"></i>
                  </div>
                  <div class="card-content">
                    <h3 class="card-value">{{numberFormat(filteredBillDetails.filter(b => b.status === 'PAID').length || 0)}}</h3>
                    <p class="card-label">PAID BILLS</p>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-6">
                <div class="summary-card orange-gradient">
                  <div class="card-icon-box">
                    <i class="bx bx-trending-up"></i>
                  </div>
                  <div class="card-content">
                    <h3 class="card-value">{{formatPrice(calculateAverage('receiptAmount'))}}</h3>
                    <p class="card-label">AVERAGE RECEIPT</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Main Content Card -->
            <div class="row">
              <div class="col-12">
                <div class="card main-table-card">
                  <!-- Filter Section -->
                  <div class="card-header filter-header">
                    <div class="filter-row">
                      <!-- Search Box -->
                      <div class="search-container">
                        <div class="search-input-wrapper">
                          <i class="bx bx-search"></i>
                          <input
                              v-model="search"
                              type="text"
                              class="form-control search-field"
                              placeholder="Search bills, transactions, names..."
                              @input="debounceSearch"
                          >
                          <button v-if="search" @click="clearSearch" class="btn-clear-search">
                            <i class="bx bx-x"></i>
                          </button>
                        </div>
                      </div>

                      <!-- Filter Controls -->
                      <div class="filter-controls-wrapper">
                        <!-- Payment Mode -->
                        <div class="filter-item">
                          <label class="filter-label">PAYMENT MODE</label>
                          <select v-model="paymentMode" @change="applyFilters" class="form-select filter-select">
                            <option value="">All Payments</option>
                            <option value="MPESA">MPESA</option>
                            <option value="BANK">BANK</option>
                          </select>
                        </div>

                        <!-- Filter By -->
                        <div class="filter-item">
                          <label class="filter-label">FILTER BY</label>
                          <select v-model="filter" @change="handleFilterChange" class="form-select filter-select">
                            <option value="">All Transactions</option>
                            <option value="filter-sub-county">Sub County</option>
                            <option value="filter-wards">Ward</option>
                            <option value="filter-zone">Zone</option>
                            <option value="filter-officer">County Agent</option>
                          </select>
                        </div>

                        <!-- Dynamic Filter Value Selector -->
                        <div class="filter-item" v-if="filter && itemList.length > 0">
                          <label class="filter-label">SELECT {{filterLabel}}</label>
                          <select v-model="selectedFilterValue" @change="applyFilters" class="form-select filter-select">
                            <option value="">All {{filterLabel}}s</option>
                            <option v-for="item in itemList" :key="item.id" :value="item.value">
                              {{item.value}}
                            </option>
                          </select>
                        </div>

                        <!-- Date Range -->
                        <div class="filter-item date-range-item">
                          <label class="filter-label">DATE RANGE</label>
                          <div class="date-range-inputs">
                            <input
                                v-model="dateFrom"
                                type="date"
                                class="form-control date-input"
                                @change="applyFilters"
                            >
                            <span class="date-separator">to</span>
                            <input
                                v-model="dateTo"
                                type="date"
                                class="form-control date-input"
                                @change="applyFilters"
                            >
                          </div>
                        </div>

                        <!-- Download Buttons -->
                        <div class="filter-item">
                          <div class="download-buttons-group">
                            <button
                                @click="downloadCurrentView"
                                class="btn btn-primary btn-download"
                                :disabled="loading || downloading || filteredBillDetails.length === 0"
                            >
                              <i class="bx bx-download"></i>
                              <span>Current ({{numberFormat(filteredBillDetails.length)}})</span>
                            </button>
                            <button
                                @click="downloadAllData"
                                class="btn btn-secondary btn-download"
                                :disabled="loading || isDownloadingAll || summary.count === 0"
                            >
                              <i class="bx bx-cloud-download"></i>
                              <span v-if="isDownloadingAll">Downloading...</span>
                              <span v-else>All ({{numberFormat(summary.count)}})</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Table Body -->
                  <div class="card-body p-0">
                    <!-- Desktop Table View -->
                    <div class="table-responsive" v-if="!loading">
                      <table class="table table-hover bills-table">
                        <thead>
                        <tr>
                          <th width="4%">#</th>
                          <th width="10%">BILL NO</th>
                          <th width="16%">DESCRIPTION</th>
                          <th width="11%">PAID BY</th>
                          <th width="12%">LOCATION</th>
                          <th width="9%">INVOICED BY</th>
                          <th width="8%" class="text-end">AMOUNT PAID</th>
                          <th width="8%" class="text-end">BILLED AMOUNT</th>
                          <th width="8%" class="text-end">RECEIPTED AMOUNT</th>
                          <th width="6%">PAYMENT</th>
                          <th width="6%">STATUS</th>
                          <th width="8%">DATE</th>
                          <th width="5%" class="text-center">ACTIONS</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in paginatedBillDetails" :key="item.id || index">
                          <td class="row-number">{{((currentPage - 1) * actualPageSize) + index + 1}}</td>
                          <td>
                            <div class="bill-no-cell">
                              <span class="bill-number">{{item.billNo || item.account_ref || 'N/A'}}</span>
                              <span class="transaction-code">{{item.transactionCode || item.transaction_code || ''}}</span>
                            </div>
                          </td>
                          <td>
                            <span class="description-text" :title="item.incomeTypeDescription || item.transaction_desc">
                              {{truncateText(item.incomeTypeDescription || item.transaction_desc || 'N/A', 50)}}
                            </span>
                          </td>
                          <td>
                            <div class="user-info-cell">
                              <div class="user-avatar">
                                {{getInitial(item.paidBy || item.names)}}
                              </div>
                              <span class="user-name">{{item.paidBy || item.names || 'N/A'}}</span>
                            </div>
                          </td>
                          <td>
                            <div class="location-info">
                              <span class="location-main">{{item.subCountyName || 'N/A'}}</span>
                              <span class="location-sub">{{item.wardName || ''}}</span>
                            </div>
                          </td>

                          <td>
                            <span class="agent-name">{{item.invoicedBy}}</span>
                          </td>

                          <td class="text-end">
                            <span class="transaction-amount">{{formatPrice(item.amount || 0)}}</span>
                          </td>
                          <td class="text-end">
                            <span class="invoice-amount">{{formatPrice(item.detailAmount || 0)}}</span>
                          </td>
                          <td class="text-end">
                            <span class="amount-value">{{formatPrice(item.receiptAmount || 0)}}</span>
                          </td>

                          <td>
                            <span class="payment-method" :class="'payment-' + (item.source || item.payment_type || '').toLowerCase()">
                              {{item.payment_type}}
                            </span>
                          </td>
                          <td>
                            <span class="status-badge" :class="getStatusClass(item.status)">
                              <i class="bx bx-circle"></i>
                              {{item.status || 'UNPAID'}}
                            </span>
                          </td>
                          <td>
                            <span class="date-text">{{formatDate(item.dateCreated || item.date)}}</span>
                          </td>
                          <td class="text-center">
                            <div class="action-buttons">
                              <button
                                  @click="viewBillDetails(item)"
                                  class="btn btn-sm btn-icon btn-primary"
                                  data-bs-toggle="modal"
                                  data-bs-target="#billDetail"
                                  title="View Details"
                              >
                                <i class="bx bx-show"></i>
                              </button>
                              <button
                                  @click="printBill(item.billNo || item.account_ref)"
                                  class="btn btn-sm btn-icon btn-secondary"
                                  title="Print"
                              >
                                <i class="bx bx-printer"></i>
                              </button>
                              <div class="dropdown d-inline-block">
                                <button
                                    class="btn btn-sm btn-icon btn-secondary"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                >
                                  <i class="bx bx-dots-vertical-rounded"></i>
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                  <li>
                                    <a class="dropdown-item" href="#" @click.prevent="sendEmail(item)">
                                      <i class="bx bx-envelope me-2"></i>Send Email
                                    </a>
                                  </li>
                                  <li>
                                    <a class="dropdown-item" href="#" @click.prevent="sendSMS(item)">
                                      <i class="bx bx-message me-2"></i>Send SMS
                                    </a>
                                  </li>
                                  <li v-if="getRight('void')"><hr class="dropdown-divider"></li>
                                  <li v-if="getRight('void')">
                                    <a class="dropdown-item text-danger" href="#" @click.prevent="voidReceipt(item)">
                                      <i class="bx bx-trash me-2"></i>Void Receipt
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                    <!-- Loading State -->
                    <div v-if="loading" class="loading-state">
                      <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      <h4>Loading Bills</h4>
                      <p>Fetching your receipt data...</p>
                    </div>

                    <!-- Empty State -->
                    <div v-if="!loading && filteredBillDetails.length === 0" class="empty-state">
                      <i class="bx bx-receipt empty-icon"></i>
                      <h3>No Bills Found</h3>
                      <p>{{emptyStateMessage}}</p>
                    </div>
                  </div>

                  <!-- Pagination Footer -->
                  <div class="card-footer" v-if="!loading && filteredBillDetails.length > 0">
                    <div class="pagination-wrapper">
                      <div class="pagination-info">
                        <span v-if="pageSize !== 'all'">
                          Showing {{paginationStart}} to {{paginationEnd}} of {{filteredBillDetails.length}} entries
                        </span>
                        <span v-else>Showing all {{filteredBillDetails.length}} entries</span>
                        <select v-model="pageSize" @change="handlePageSizeChange" class="form-select page-size-select">
                          <option value="10">10 per page</option>
                          <option value="25">25 per page</option>
                          <option value="50">50 per page</option>
                          <option value="100">100 per page</option>
                          <option value="200">200 per page</option>
                          <option value="500">500 per page</option>
                          <option value="1000">1000 per page</option>
                          <option value="all">All</option>
                        </select>
                      </div>

                      <nav v-if="pageSize !== 'all'">
                        <ul class="pagination">
                          <li class="page-item" :class="{disabled: currentPage === 1}">
                            <a class="page-link" @click="goToFirstPage">
                              <i class="bx bx-chevrons-left"></i>
                            </a>
                          </li>
                          <li class="page-item" :class="{disabled: currentPage === 1}">
                            <a class="page-link" @click="prevPage">
                              <i class="bx bx-chevron-left"></i>
                            </a>
                          </li>
                          <li
                              v-for="page in visiblePages"
                              :key="'page-' + page"
                              class="page-item"
                              :class="{active: page === currentPage}"
                          >
                            <a class="page-link" @click="goToPage(page)" v-if="page !== '...'">{{page}}</a>
                            <span class="page-link" v-else>...</span>
                          </li>
                          <li class="page-item" :class="{disabled: currentPage === totalPages}">
                            <a class="page-link" @click="nextPage">
                              <i class="bx bx-chevron-right"></i>
                            </a>
                          </li>
                          <li class="page-item" :class="{disabled: currentPage === totalPages}">
                            <a class="page-link" @click="goToLastPage">
                              <i class="bx bx-chevrons-right"></i>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- Download Progress Modal with Pause/Resume and Time Estimation -->
        <div class="modal fade" id="downloadProgressModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header bg-primary text-white">
                <h5 class="modal-title text-white">
                  <i class="bx bxs-download me-2"></i>Downloading All Receipts
                </h5>
              </div>
              <div class="modal-body">
                <div class="text-center mb-3">
                  <div class="spinner-border text-primary mb-3" style="width: 3rem; height: 3rem;" role="status" v-if="!downloadPaused">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <div v-else class="mb-3">
                    <i class="bx bx-pause-circle text-warning" style="font-size: 3rem;"></i>
                  </div>
                  <h5 v-if="!downloadPaused">Please wait while we download your records...</h5>
                  <h5 v-else class="text-warning">Download Paused</h5>

                  <!-- Estimated Time Remaining -->
                  <div v-if="downloadProgress.estimatedTimeRemaining && !downloadPaused" class="mt-2">
                    <p class="text-muted mb-1">
                      <i class="bx bx-time-five me-1"></i>
                      <strong>{{ formatTimeRemaining(downloadProgress.estimatedTimeRemaining) }}</strong> remaining
                    </p>
                    <small class="text-muted">
                      Average speed: {{ downloadProgress.averageSpeed }} records/sec
                    </small>
                  </div>

                  <p class="text-muted mt-2">{{ downloadPaused ? 'You can resume or cancel the download.' : 'This may take several minutes depending on the amount of data.' }}</p>
                </div>

                <div class="progress mb-3" style="height: 25px;">
                  <div
                      class="progress-bar progress-bar-striped"
                      :class="{'progress-bar-animated': !downloadPaused, 'bg-warning': downloadPaused}"
                      role="progressbar"
                      :style="{ width: downloadProgress.percentage + '%' }"
                      :aria-valuenow="downloadProgress.percentage"
                      aria-valuemin="0"
                      aria-valuemax="100">
                    {{ downloadProgress.percentage }}%
                  </div>
                </div>

                <div class="d-flex justify-content-between text-muted small mb-3">
                  <span>Page {{ downloadProgress.current }} of {{ downloadProgress.total }}</span>
                  <span>{{ downloadProgress.records }} / {{ numberFormat(downloadProgress.totalRecords) }} records</span>
                </div>

                <!-- Error Display -->
                <div v-if="downloadError" class="alert alert-danger d-flex align-items-center" role="alert">
                  <i class="bx bx-error-circle me-2"></i>
                  <div class="flex-grow-1">
                    <strong>Error:</strong> {{ downloadError }}
                    <br>
                    <small>You can retry from where it stopped or cancel the download.</small>
                  </div>
                </div>

                <!-- Retry Count Display -->
                <div v-if="downloadRetryCount > 0" class="alert alert-warning d-flex align-items-center mb-3" role="alert">
                  <i class="bx bx-info-circle me-2"></i>
                  <small>Retry attempt {{ downloadRetryCount }} of 3</small>
                </div>

                <!-- Action Buttons -->
                <div class="d-flex gap-2 justify-content-center mb-3">
                  <button
                      v-if="!downloadPaused && !downloadError"
                      @click="pauseDownload"
                      class="btn btn-warning btn-sm">
                    <i class="bx bx-pause me-1"></i>Pause
                  </button>
                  <button
                      v-if="downloadPaused || downloadError"
                      @click="resumeDownload"
                      class="btn btn-success btn-sm">
                    <i class="bx bx-play me-1"></i>Resume
                  </button>
                  <button
                      @click="cancelDownload"
                      class="btn btn-danger btn-sm">
                    <i class="bx bx-x me-1"></i>Cancel
                  </button>
                </div>

                <div class="alert alert-info d-flex align-items-center" role="alert">
                  <i class="bx bx-info-circle me-2"></i>
                  <small>{{ downloadPaused ? 'Download is paused. Your progress has been saved.' : 'Please do not close this window or navigate away.' }}</small>
                </div>

                <!-- Download Statistics -->
                <div v-if="downloadProgress.records > 0" class="mt-3 pt-3 border-top">
                  <div class="row text-center">
                    <div class="col-4">
                      <small class="text-muted d-block">Downloaded</small>
                      <strong>{{ numberFormat(downloadProgress.records) }}</strong>
                    </div>
                    <div class="col-4">
                      <small class="text-muted d-block">Remaining</small>
                      <strong>{{ numberFormat(downloadProgress.totalRecords - downloadProgress.records) }}</strong>
                    </div>
                    <div class="col-4">
                      <small class="text-muted d-block">Success Rate</small>
                      <strong>{{ getSuccessRate() }}%</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Bill Detail Modal -->
        <div
            class="modal fade"
            id="billDetail"
            tabindex="-1"
            aria-labelledby="billDetailLabel"
            aria-hidden="true"
        >
          <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="billDetailLabel">
                  <i class="bx bx-receipt me-2"></i>Bill Details
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <div class="bill-detail-header">
                  <div class="detail-info">
                    <h3 class="bill-number-large">{{currentBill.billNo}}</h3>
                    <p class="bill-meta">Created on {{formatDate(currentBill.dateCreated)}}</p>
                  </div>
                  <div class="detail-status">
                    <span class="status-badge-large" :class="getStatusClass(currentBill.status)">
                      {{currentBill.status || 'UNPAID'}}
                    </span>
                  </div>
                </div>

                <div class="bill-detail-customer">
                  <h6 class="section-title">Customer Information</h6>
                  <div class="customer-info">
                    <div class="info-item">
                      <span class="info-label">Name:</span>
                      <span class="info-value">{{currentBill.paidBy || currentBill.names || 'N/A'}}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">ID Number:</span>
                      <span class="info-value">{{maskPhoneNumber(currentBill.idNo) || 'N/A'}}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Phone:</span>
                      <span class="info-value">{{maskPhoneNumber(currentBill.phoneNumber) || 'N/A'}}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Location:</span>
                      <span class="info-value">{{currentBill.subCountyName}} - {{currentBill.wardName}}</span>
                    </div>
                  </div>
                </div>

                <div class="bill-detail-items">
                  <h6 class="section-title">Transaction Details</h6>
                  <div class="table-responsive">
                    <table class="table table-modal">
                      <thead>
                      <tr>
                        <th width="15%">Transaction Code</th>
                        <th width="45%">Description</th>
                        <th width="20%" class="text-end">Invoice Amount</th>
                        <th width="20%" class="text-end">Receipt Amount</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td>{{currentBill.transactionCode || 'N/A'}}</td>
                        <td>{{currentBill.incomeTypeDescription || 'N/A'}}</td>
                        <td class="text-end">{{formatPrice(currentBill.detailAmount || 0)}}</td>
                        <td class="text-end fw-bold">{{formatPrice(currentBill.receiptAmount || 0)}}</td>
                      </tr>
                      </tbody>
                      <tfoot>
                      <tr class="table-total">
                        <td colspan="3" class="text-end fw-bold">Payment Method:</td>
                        <td class="text-end">
                          <span class="payment-method" :class="'payment-' + (currentBill.payment_type || '').toLowerCase()">
                            {{currentBill.payment_type || ''}}
                          </span>
                        </td>
                      </tr>
                      <tr class="table-total" v-if="currentBill.billBalance > 0">
                        <td colspan="3" class="text-end fw-bold">Outstanding Balance:</td>
                        <td class="text-end">
                          <h4 class="m-0 text-danger">{{formatPrice(currentBill.billBalance || 0)}}</h4>
                        </td>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" @click="printReceipt(currentBill)">
                  <i class="bx bx-printer me-2"></i>Print Receipt
                </button>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                © 2024 County Revenue System
              </div>
              <div class="col-sm-6">
                <div class="text-sm-end">Developed by County IT Department</div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import {authUrl, biller, execute, executeDownload, getRight} from "@/api";
import NavigationBar from "@/components/Navigation.vue";
import router from "@/router";
import moment from "moment";

export default {
  name: "Receipts",
  components: {NavigationBar},
  data() {
    return {
      // Filter states
      paymentMode: '',
      search: '',
      filter: '',
      selectedFilterValue: '',
      dateFrom: '',
      dateTo: '',

      // Loading states
      loading: false,
      downloading: false,
      searchTimeout: null,

      // Pagination
      currentPage: 1,
      totalPages: 1,
      pageSize: '25',

      // Data - separated into all data and filtered data
      allBillDetails: [], // All data from API
      filteredBillDetails: [], // Filtered data based on search/filters

      // Current selection
      currentBill: {},

      // Filter options
      itemList: [],
      filterLabel: '',

      // Summary
      summary: { count: 0, total: 0 },

      // Messages
      message: '',
      emptyStateMessage: 'There are no receipted bills to display.',

      // Download All functionality with pause/resume and time estimation
      isDownloadingAll: false,
      downloadPaused: false,
      downloadCancelled: false,
      downloadError: null,
      downloadRetryCount: 0,
      maxRetries: 3,
      downloadProgress: {
        current: 0,
        total: 0,
        percentage: 0,
        records: 0,
        totalRecords: 0,
        startTime: null,
        estimatedTimeRemaining: null,
        averageSpeed: 0
      },
      allRecordsData: [],
      downloadState: {
        startPage: 1,
        currentPage: 0,
        batchSize: 1000,
        totalPages: 0,
        accumulatedData: []
      }
    }
  },

  computed: {
    actualPageSize() {
      return this.pageSize === 'all' ? this.filteredBillDetails.length : parseInt(this.pageSize);
    },

    paginatedBillDetails() {
      if (this.pageSize === 'all') {
        return this.filteredBillDetails;
      }

      const start = (this.currentPage - 1) * this.actualPageSize;
      const end = start + this.actualPageSize;
      return this.filteredBillDetails.slice(start, end);
    },

    visiblePages() {
      return this.pagination(this.currentPage, this.totalPages, 5);
    },

    paginationStart() {
      if (this.filteredBillDetails.length === 0) return 0;
      return ((this.currentPage - 1) * this.actualPageSize) + 1;
    },

    paginationEnd() {
      if (this.pageSize === 'all') return this.filteredBillDetails.length;
      const end = this.currentPage * this.actualPageSize;
      return Math.min(end, this.filteredBillDetails.length);
    }
  },

  mounted() {
    // Set default date range
    this.dateFrom = moment().startOf('month').format('YYYY-MM-DD');
    this.dateTo = moment().format('YYYY-MM-DD');

    // Initial load
    this.loadBills();

    // Check menu access
    this.checkMenuAccess();

    // Load filter data if needed
    if (sessionStorage.getItem("filterType")) {
      this.filter = sessionStorage.getItem("filterType");
      this.handleFilterChange();
    }
  },

  watch: {
    filteredBillDetails() {
      // Recalculate pagination when filtered data changes
      this.calculatePagination();
    }
  },

  methods: {
    // Utility methods
    numberFormat(num) {
      return new Intl.NumberFormat("en-GB").format(num || 0);
    },

    formatPrice(value) {
      const num = parseFloat(value) || 0;
      return new Intl.NumberFormat('en-KE', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      }).format(num);
    },

    formatDate(dateString) {
      if (!dateString) return 'N/A';
      return moment(dateString).format('DD MMM YYYY');
    },

    truncateText(text, maxLength) {
      if (!text) return 'N/A';
      if (text.length <= maxLength) return text;
      return text.substring(0, maxLength) + '...';
    },

    getInitial(name) {
      if (!name) return 'U';
      return name.charAt(0).toUpperCase();
    },

    maskPhoneNumber(input) {
      if (!input || typeof input !== 'string') return input;

      const digits = input.replace(/\D/g, '');
      if (digits.length > 4) {
        return input.slice(0, 2) +
            input.slice(2, -2).replace(/\d/g, '*') +
            input.slice(-2);
      }
      return input;
    },

    getStatusClass(status) {
      switch(status) {
        case 'PAID':
          return 'status-paid';
        case 'PARTIAL':
          return 'status-partial';
        case 'PENDING':
          return 'status-pending';
        default:
          return 'status-unpaid';
      }
    },

    // Format time remaining in human-readable format
    formatTimeRemaining(seconds) {
      if (!seconds || seconds <= 0) return 'Calculating...';

      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = Math.floor(seconds % 60);

      if (hours > 0) {
        return `${hours}h ${minutes}m ${secs}s`;
      } else if (minutes > 0) {
        return `${minutes}m ${secs}s`;
      } else {
        return `${secs}s`;
      }
    },

    // Calculate estimated time remaining
    calculateEstimatedTime() {
      if (!this.downloadProgress.startTime || this.downloadProgress.current === 0) {
        return;
      }

      const elapsedTime = (Date.now() - this.downloadProgress.startTime) / 1000;
      const recordsDownloaded = this.downloadProgress.records;
      const remainingRecords = this.downloadProgress.totalRecords - recordsDownloaded;

      if (recordsDownloaded > 0 && elapsedTime > 0) {
        const averageSpeed = recordsDownloaded / elapsedTime;
        this.downloadProgress.averageSpeed = averageSpeed.toFixed(2);

        const estimatedTimeRemaining = remainingRecords / averageSpeed;
        this.downloadProgress.estimatedTimeRemaining = estimatedTimeRemaining;
      }
    },

    // Get Success Rate
    getSuccessRate() {
      if (this.downloadProgress.total === 0) return 100;
      const successfulPages = this.downloadProgress.current - this.downloadRetryCount;
      return Math.round((successfulPages / this.downloadProgress.total) * 100);
    },

    // Pause Download
    pauseDownload() {
      this.downloadPaused = true;
      console.log('Download paused at page:', this.downloadState.currentPage);
    },

    // Resume Download
    async resumeDownload() {
      this.downloadPaused = false;
      this.downloadError = null;
      this.downloadRetryCount = 0;

      console.log('Resuming download from page:', this.downloadState.currentPage + 1);

      await this.continueDownload();
    },

    // Cancel Download
    cancelDownload() {
      const confirmed = confirm('Are you sure you want to cancel the download? All progress will be lost.');

      if (confirmed) {
        this.downloadCancelled = true;
        this.closeDownloadModal();
      }
    },

    // Close Download Modal
    closeDownloadModal() {
      const modalElement = document.getElementById('downloadProgressModal');
      if (modalElement) {
        const existingModal = bootstrap.Modal.getInstance(modalElement);
        if (existingModal) {
          existingModal.hide();
        }
      }

      document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';

      // Reset state
      this.isDownloadingAll = false;
      this.downloadPaused = false;
      this.downloadCancelled = false;
      this.downloadError = null;
      this.downloadRetryCount = 0;
      this.allRecordsData = [];
      this.downloadProgress = {
        current: 0,
        total: 0,
        percentage: 0,
        records: 0,
        totalRecords: 0,
        startTime: null,
        estimatedTimeRemaining: null,
        averageSpeed: 0
      };
      this.downloadState = {
        startPage: 1,
        currentPage: 0,
        batchSize: 1000,
        totalPages: 0,
        accumulatedData: []
      };
    },

    // Main data loading method
    async loadBills() {
      this.loading = true;
      this.allBillDetails = [];
      this.filteredBillDetails = [];

      try {
        const data = new FormData();
        data.append("function", "getReceiptsDetailsPaginated");
        data.append("page", 1);
        data.append("rows_per_page", 10000);
        data.append("status", "PAID");

        // Add date filters to API call
        if (this.dateFrom) {
          data.append("dateFrom", this.dateFrom);
        }
        if (this.dateTo) {
          data.append("dateTo", this.dateTo);
        }

        // Add payment method filter
        if (this.paymentMode) {
          data.append("payment_method", this.paymentMode);
        }

        // Add search keyword
        if (this.search) {
          data.append("keyword", this.search);
        }

        // Add other filters if selected
        if (this.selectedFilterValue) {
          switch(this.filter) {
            case 'filter-sub-county':
              data.append("subCountyID", this.selectedFilterValue);
              break;
            case 'filter-wards':
              data.append("wardID", this.selectedFilterValue);
              break;
            case 'filter-zone':
              data.append("zone", this.selectedFilterValue);
              break;
            case 'filter-officer':
              data.append("createdBy", this.selectedFilterValue);
              break;
          }
        }

        const response = await execute(data, biller);

        if (response.data.success) {
          this.allBillDetails = response.data.data.billDetails || [];
          this.filteredBillDetails = [...this.allBillDetails];
          this.summary = response.data.data.summary || { count: 0, total: 0 };

          if (this.allBillDetails.length === 0) {
            this.emptyStateMessage = 'No receipt data available.';
          }
        } else {
          this.message = response.data.message || 'Failed to load bills';
          this.showToast(this.message, 'error');
        }
      } catch (error) {
        console.error('Error loading bills:', error);
        this.message = error.message || 'An error occurred while loading bills';
        this.showToast(this.message, 'error');
      } finally {
        this.loading = false;
      }
    },

    // Client-side filtering method
    applyFilters() {
      // For server-side filtering, reload data from API
      this.loadBills();
    },

    // Calculate pagination info
    calculatePagination() {
      if (this.pageSize === 'all') {
        this.totalPages = 1;
      } else {
        this.totalPages = Math.ceil(this.filteredBillDetails.length / this.actualPageSize);
      }
    },

    // Debounced search
    debounceSearch() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.applyFilters();
      }, 500);
    },

    // Clear search
    clearSearch() {
      this.search = '';
      this.applyFilters();
    },

    // Handle filter type change
    async handleFilterChange() {
      this.selectedFilterValue = '';
      this.itemList = [];

      if (!this.filter) {
        this.applyFilters();
        return;
      }

      // Extract unique values from current data for filters
      this.extractFilterOptions();
      this.applyFilters();
    },

    // Extract filter options from data
    extractFilterOptions() {
      const uniqueValues = new Set();

      switch(this.filter) {
        case 'filter-sub-county':
          this.filterLabel = 'Sub County';
          this.allBillDetails.forEach(item => {
            if (item.subCountyName) uniqueValues.add(item.subCountyName);
          });
          break;
        case 'filter-wards':
          this.filterLabel = 'Ward';
          this.allBillDetails.forEach(item => {
            if (item.wardName) uniqueValues.add(item.wardName);
          });
          break;
        case 'filter-zone':
          this.filterLabel = 'Zone';
          this.allBillDetails.forEach(item => {
            if (item.zoneName) uniqueValues.add(item.zoneName);
          });
          break;
        case 'filter-officer':
          this.filterLabel = 'Agent';
          this.allBillDetails.forEach(item => {
            if (item.invoicedBy) uniqueValues.add(item.invoicedBy);
            if (item.receiptedBy) uniqueValues.add(item.receiptedBy);
          });
          break;
      }

      this.itemList = Array.from(uniqueValues)
          .sort()
          .map((value, index) => ({
            id: index + 1,
            value: value
          }));
    },

    // Client-side CSV download for current view
    downloadCurrentView() {
      this.downloading = true;

      try {
        const csvData = this.generateCSV(this.filteredBillDetails);
        const filename = this.generateFilename('Filtered_Receipts');
        this.downloadCSV(csvData, filename);
        this.showToast(`Downloaded ${this.filteredBillDetails.length} filtered receipts`, 'success');
      } catch (error) {
        console.error('Download error:', error);
        this.showToast('Failed to download current view', 'error');
      } finally {
        this.downloading = false;
      }
    },

    // Download All Records with Pause/Resume/Retry and Time Estimation
    async downloadAllData() {
      if (!this.dateFrom || !this.dateTo) {
        this.showToast('Please select date range before downloading', 'warning');
        return;
      }

      const isConfirmed = confirm(
          `You are about to download all ${this.numberFormat(this.summary.count)} receipts from ${this.dateFrom} to ${this.dateTo}. This may take several minutes. Do you want to continue?`
      );

      if (!isConfirmed) return;

      this.isDownloadingAll = true;
      this.downloadPaused = false;
      this.downloadCancelled = false;
      this.downloadError = null;
      this.downloadRetryCount = 0;
      this.allRecordsData = [];

      const batchSize = 1000;
      const totalRecords = this.summary.count;
      const totalPages = Math.ceil(totalRecords / batchSize);

      this.downloadState = {
        startPage: 1,
        currentPage: 0,
        batchSize: batchSize,
        totalPages: totalPages,
        accumulatedData: []
      };

      this.downloadProgress = {
        current: 0,
        total: totalPages,
        percentage: 0,
        records: 0,
        totalRecords: totalRecords,
        startTime: Date.now(),
        estimatedTimeRemaining: null,
        averageSpeed: 0
      };

      const modalElement = document.getElementById('downloadProgressModal');
      const progressModal = new bootstrap.Modal(modalElement);
      progressModal.show();

      await this.continueDownload();
    },

    // Continue Download (used by both initial download and resume)
    async continueDownload() {
      try {
        const startPage = this.downloadState.currentPage + 1;
        const totalPages = this.downloadState.totalPages;

        for (let page = startPage; page <= totalPages; page++) {
          if (this.downloadPaused) {
            console.log('Download paused, waiting for resume...');
            return;
          }

          if (this.downloadCancelled) {
            console.log('Download cancelled by user');
            return;
          }

          try {
            this.downloadState.currentPage = page;
            this.downloadProgress.current = page;
            this.downloadProgress.percentage = Math.round((page / totalPages) * 100);

            const pageData = await this.fetchReceiptsPageWithRetry(page, this.downloadState.batchSize);

            if (pageData && pageData.length > 0) {
              this.downloadState.accumulatedData = [...this.downloadState.accumulatedData, ...pageData];
              this.allRecordsData = this.downloadState.accumulatedData;
              this.downloadProgress.records = this.allRecordsData.length;

              this.calculateEstimatedTime();
            }

            this.downloadRetryCount = 0;
            this.downloadError = null;

            await this.delay(50);

          } catch (error) {
            console.error(`Error fetching page ${page}:`, error);
            this.downloadError = error.message;
            this.downloadPaused = true;
            return;
          }
        }

        await this.finalizeDownload();

      } catch (error) {
        console.error('Download error:', error);
        this.downloadError = error.message;
        this.downloadPaused = true;
      }
    },

    // Fetch Receipts Page with Retry Logic
    async fetchReceiptsPageWithRetry(page, rowsPerPage, retryCount = 0) {
      try {
        const data = new FormData();
        data.append("function", "getReceiptsDetailsPaginated");
        data.append("page", page);
        data.append("rows_per_page", rowsPerPage);
        data.append("status", "PAID");

        if (this.dateFrom) data.append("dateFrom", this.dateFrom);
        if (this.dateTo) data.append("dateTo", this.dateTo);
        if (this.paymentMode) data.append("payment_method", this.paymentMode);
        if (this.search) data.append("keyword", this.search);

        if (this.selectedFilterValue) {
          switch(this.filter) {
            case 'filter-sub-county':
              data.append("subCountyID", this.selectedFilterValue);
              break;
            case 'filter-wards':
              data.append("wardID", this.selectedFilterValue);
              break;
            case 'filter-zone':
              data.append("zone", this.selectedFilterValue);
              break;
            case 'filter-officer':
              data.append("createdBy", this.selectedFilterValue);
              break;
          }
        }

        const res = await execute(data, biller);

        if (res.data.success) {
          return res.data.data.billDetails || [];
        } else {
          throw new Error(res.data.message || 'Failed to fetch page data');
        }
      } catch (error) {
        if (retryCount < this.maxRetries) {
          this.downloadRetryCount = retryCount + 1;
          console.log(`Retry ${this.downloadRetryCount} for page ${page}`);

          const waitTime = Math.pow(2, retryCount) * 1000;
          await this.delay(waitTime);

          return this.fetchReceiptsPageWithRetry(page, rowsPerPage, retryCount + 1);
        } else {
          throw new Error(`Failed after ${this.maxRetries} retries: ${error.message}`);
        }
      }
    },

    // Finalize Download
    async finalizeDownload() {
      if (this.allRecordsData.length > 0) {
        const csv = this.generateCSV(this.allRecordsData);

        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        const fileName = this.generateFilename('All_Receipts');

        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        await this.delay(500);

        this.showToast(`Successfully downloaded ${this.allRecordsData.length} receipts!`, 'success');

        this.closeDownloadModal();
      } else {
        this.showToast('No records found to download', 'info');
        this.closeDownloadModal();
      }
    },

    // Delay helper function
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    // Generate CSV content from data - WITHOUT "Receipted By"
    // Generate CSV content from data - WITHOUT "Receipted By", "Phone Number", and "Zone"
    generateCSV(data) {
      // Define CSV headers - REMOVED "Receipted By", "Phone Number", and "Zone"
      const headers = [
        'Bill Number',
        'Transaction Code',
        'Description',
        'Paid By',
        'Sub County',
        'Ward',
        'Invoiced By',
        'Amount Paid',
        'Billed Amount',
        'Receipted Amount',
        'Payment Method',
        'Status',
        'Date Created',
        'ID Number'
      ];

      // Create CSV rows
      const rows = data.map(item => [
        this.escapeCSVField(item.billNo || item.account_ref || ''),
        this.escapeCSVField(item.transactionCode || item.transaction_code || ''),
        this.escapeCSVField(item.incomeTypeDescription || item.transaction_desc || ''),
        this.escapeCSVField(item.paidBy || item.names || ''),
        this.escapeCSVField(item.subCountyName || ''),
        this.escapeCSVField(item.wardName || ''),
        this.escapeCSVField(item.invoicedBy || ''),
        this.formatPriceForCSV(item.amount || 0),
        this.formatPriceForCSV(item.detailAmount || 0),
        this.formatPriceForCSV(item.receiptAmount || 0),
        this.escapeCSVField(item.payment_type),
        this.escapeCSVField(item.status || ''),
        this.formatDateForCSV(item.dateCreated || item.date),
        this.escapeCSVField(item.idNo || '')
      ]);

      // Combine headers and rows
      const csvContent = [headers, ...rows]
          .map(row => row.join(','))
          .join('\n');

      return csvContent;
    },

    // Escape CSV field to handle commas, quotes, etc.
    escapeCSVField(field) {
      if (field == null) return '';

      const str = String(field);
      // If field contains comma, quote, or newline, wrap in quotes and escape internal quotes
      if (str.includes(',') || str.includes('"') || str.includes('\n') || str.includes('\r')) {
        return '"' + str.replace(/"/g, '""') + '"';
      }
      return str;
    },

    // Format price for CSV (remove currency symbol)
    formatPriceForCSV(value) {
      const num = parseFloat(value) || 0;
      return num.toFixed(2);
    },

    // Format date for CSV
    formatDateForCSV(dateString) {
      if (!dateString) return '';
      return moment(dateString).format('DD/MM/YYYY HH:mm:ss');
    },

    // Generate filename based on filters
    generateFilename(prefix) {
      let filename = prefix;

      if (this.dateFrom && this.dateTo) {
        filename += `_${this.dateFrom}_to_${this.dateTo}`;
      }

      if (this.paymentMode) {
        filename += `_${this.paymentMode}`;
      }

      if (this.selectedFilterValue) {
        filename += `_${this.selectedFilterValue.replace(/\s+/g, '_')}`;
      }

      filename += `_${moment().format('YYYY-MM-DD_HHmmss')}`;
      filename += '.csv';

      return filename;
    },

    // Download CSV file
    downloadCSV(csvContent, filename) {
      // Create blob
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

      // Create download link
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';

      // Trigger download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up
      URL.revokeObjectURL(url);
    },

    // Calculate totals
    calculateTotal(field) {
      return this.filteredBillDetails.reduce((sum, item) => {
        return sum + (parseFloat(item[field]) || 0);
      }, 0);
    },

    // Calculate averages
    calculateAverage(field) {
      if (this.filteredBillDetails.length === 0) return 0;
      return this.calculateTotal(field) / this.filteredBillDetails.length;
    },

    // View bill details
    viewBillDetails(item) {
      this.currentBill = {...item};

      // Load additional bill details if needed
      if (item.billNo) {
        this.loadBillDetails(item.billNo, item.transactionCode);
      }
    },

    async loadBillDetails(billNo, transactionCode) {
      try {
        const data = new FormData();
        data.append("function", "getBill");
        data.append("billNo", billNo);
        if (transactionCode) {
          data.append("transactionCode", transactionCode);
        }

        const response = await execute(data, biller);
        if (response.data.success) {
          // Merge detailed info with current bill
          Object.assign(this.currentBill, response.data.data.billDetails);
        }
      } catch (error) {
        console.error('Error loading bill details:', error);
      }
    },

    // Print functions
    printBill(billNo) {
      if (!billNo) return;

      localStorage['params'] = JSON.stringify({ billNo: billNo });
      const routeData = this.$router.resolve({ name: 'bill' });
      window.open(routeData.href, '_blank');
    },

    printReceipt(bill) {
      if (!bill.transactionCode) {
        this.showToast('Receipt number not available', 'warning');
        return;
      }

      localStorage['params'] = JSON.stringify({
        receiptNo: bill.transactionCode,
        billNo: bill.billNo
      });
      const routeData = this.$router.resolve({ name: 'receipt' });
      window.open(routeData.href, '_blank');
    },

    // Action methods
    sendEmail(item) {
      // Implement email sending
      console.log('Send email for', item);
      this.showToast('Email functionality coming soon', 'info');
    },

    sendSMS(item) {
      // Implement SMS sending
      console.log('Send SMS for', item);
      this.showToast('SMS functionality coming soon', 'info');
    },

    async voidReceipt(item) {
      if (!confirm(`Are you sure you want to void receipt ${item.transactionCode}?`)) {
        return;
      }

      try {
        const data = new FormData();
        data.append("function", "voidReceipt");
        data.append("receiptNo", item.transactionCode);
        data.append("reason", "Voided by user");

        const response = await execute(data, biller);
        if (response.data.success) {
          this.showToast('Receipt voided successfully', 'success');
          this.loadBills();
        } else {
          this.showToast(response.data.message || 'Failed to void receipt', 'error');
        }
      } catch (error) {
        console.error('Error voiding receipt:', error);
        this.showToast('An error occurred while voiding receipt', 'error');
      }
    },

    // Pagination methods
    handlePageSizeChange() {
      this.currentPage = 1;
      this.calculatePagination();
    },

    goToFirstPage() {
      if (this.currentPage !== 1) {
        this.currentPage = 1;
      }
    },

    goToLastPage() {
      if (this.currentPage !== this.totalPages) {
        this.currentPage = this.totalPages;
      }
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },

    goToPage(page) {
      if (page !== '...' && page !== this.currentPage) {
        this.currentPage = page;
      }
    },

    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);

      if (start < 1) {
        start = 1;
        end = Math.min(start + maxVisibleButtons - 1, totalPages);
      }

      if (end > totalPages) {
        end = totalPages;
        start = Math.max(end - maxVisibleButtons + 1, 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (start > 1) {
        pages.unshift("...");
        pages.unshift(1);
      }

      if (end < totalPages) {
        pages.push("...");
        pages.push(totalPages);
      }

      return pages;
    },

    updateEmptyStateMessage() {
      let message = 'No receipts found';

      if (this.search) {
        message += ` matching "${this.search}"`;
      }
      if (this.paymentMode) {
        message += ` for ${this.paymentMode} payments`;
      }
      if (this.dateFrom && this.dateTo) {
        message += ` between ${this.formatDate(this.dateFrom)} and ${this.formatDate(this.dateTo)}`;
      }

      this.emptyStateMessage = message + '.';
    },

    showToast(message, type = 'info') {
      // Implement your toast notification system
      console.log(`[${type.toUpperCase()}]:`, message);

      // If you have a toast library, use it here
      // For example with bootstrap toast or vue-toastification
    },

    checkMenuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Receipt Payment");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, biller)
          .then(response => {
            if (!response.data.success) {
              // Redirect if no access
              this.$router.push('/dashboard');
            }
          })
          .catch(error => {
            console.error('Menu access check failed:', error);
          });
    },

    getRight(type) {
      return getRight(type);
    },

    gotTo(route) {
      this.$router.push(route);
    }
  }
}
</script>

<style scoped>
/* Enhanced Header Section */
.page-header-enhanced {
  background: linear-gradient(135deg, #0891b2 0%, #06b6d4 50%, #0ea5e9 100%);
  padding: 1.5rem;
  border-radius: 12px;
  margin-bottom: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
}

.page-header-enhanced::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%);
  animation: shimmer 15s infinite linear;
}

@keyframes shimmer {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.header-content-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.header-left {
  flex: 1;
}

.page-main-title {
  color: white;
  font-size: 1.75rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
}

.breadcrumb-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.875rem;
}

.breadcrumb-container i {
  font-size: 1rem;
}

.breadcrumb-link {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  cursor: pointer;
  transition: color 0.3s;
}

.breadcrumb-link:hover {
  color: white;
}

.breadcrumb-divider {
  color: rgba(255, 255, 255, 0.6);
  margin: 0 0.25rem;
}

.breadcrumb-current {
  color: white;
}

.header-right {
  display: flex;
  gap: 1rem;
}

.header-stat-badge {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  padding: 0.75rem 1.25rem;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.header-stat-badge.primary {
  background: rgba(255, 255, 255, 0.25);
}

.stat-number {
  color: white;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1;
}

.stat-text {
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.625rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 0.25rem;
}

/* Summary Cards */
.summary-cards-row {
  margin-bottom: 1.5rem;
}

.summary-card {
  background: white;
  border-radius: 12px;
  padding: 1.25rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  gap: 1rem;
  transition: all 0.3s;
  margin-bottom: 1rem;
  position: relative;
  overflow: hidden;
}

.summary-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
}

.purple-gradient::before {
  background: linear-gradient(90deg, #0891b2 0%, #06b6d4 100%);
}

.green-gradient::before {
  background: linear-gradient(90deg, #10b981 0%, #34d399 100%);
}

.cyan-gradient::before {
  background: linear-gradient(90deg, #8b5cf6 0%, #a78bfa 100%);
}

.orange-gradient::before {
  background: linear-gradient(90deg, #f59e0b 0%, #fbbf24 100%);
}

.summary-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}

.card-icon-box {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}

.purple-gradient .card-icon-box {
  background: rgba(8, 145, 178, 0.1);
  color: #0891b2;
}

.green-gradient .card-icon-box {
  background: rgba(16, 185, 129, 0.1);
  color: #10b981;
}

.cyan-gradient .card-icon-box {
  background: rgba(139, 92, 246, 0.1);
  color: #8b5cf6;
}

.orange-gradient .card-icon-box {
  background: rgba(245, 158, 11, 0.1);
  color: #f59e0b;
}

.card-content {
  flex: 1;
}

.card-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 0.25rem 0;
}

.card-label {
  font-size: 0.625rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0;
}

/* Main Table Card */
.main-table-card {
  border: none;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

/* Filter Section */
.filter-header {
  background: white;
  border-bottom: 1px solid #e5e7eb;
  padding: 1.25rem;
}

.filter-row {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.search-container {
  width: 100%;
  max-width: 400px;
}

.search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-input-wrapper i {
  position: absolute;
  left: 1rem;
  color: #6b7280;
  pointer-events: none;
}

.search-field {
  padding-left: 2.75rem;
  padding-right: 2.75rem;
  height: 42px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 0.875rem;
  width: 100%;
}

.search-field:focus {
  border-color: #7c3aed;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);
  outline: none;
}

.btn-clear-search {
  position: absolute;
  right: 0.5rem;
  background: transparent;
  border: none;
  padding: 0.5rem;
  color: #6b7280;
  cursor: pointer;
  transition: color 0.3s;
}

.btn-clear-search:hover {
  color: #ef4444;
}

.filter-controls-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: flex-end;
}

.filter-item {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  min-width: 140px;
}

.filter-label {
  font-size: 0.625rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.filter-select,
.date-input {
  height: 38px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 0.875rem;
  padding: 0 0.75rem;
}

.filter-select:focus,
.date-input:focus {
  border-color: #7c3aed;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);
  outline: none;
}

.date-range-item {
  min-width: 280px;
}

.date-range-inputs {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.date-separator {
  color: #6b7280;
  font-size: 0.875rem;
}

.btn-download {
  height: 38px;
  padding: 0 1.25rem;
  background: linear-gradient(135deg, #0891b2 0%, #06b6d4 100%);
  border: none;
  border-radius: 6px;
  color: white;
  font-size: 0.875rem;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: all 0.3s;
  margin-top: 1.375rem;
}

.btn-download:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(8, 145, 178, 0.3);
  background: linear-gradient(135deg, #0ea5e9 0%, #0891b2 100%);
}

.btn-download:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Table Styles */
.bills-table {
  width: 100%;
  margin-bottom: 0;
}

.bills-table thead {
  background: #f9fafb;
  border-bottom: 2px solid #e5e7eb;
}

.bills-table thead th {
  padding: 0.75rem;
  font-size: 0.625rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border: none;
}

.bills-table tbody tr {
  border-bottom: 1px solid #f3f4f6;
  transition: background-color 0.2s;
}

.bills-table tbody tr:hover {
  background-color: #f9fafb;
}

.bills-table tbody td {
  padding: 0.875rem 0.75rem;
  vertical-align: middle;
  font-size: 0.875rem;
  color: #374151;
}

.row-number {
  font-weight: 500;
  color: #6b7280;
}

.bill-no-cell {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}

.bill-number {
  font-weight: 600;
  color: #0891b2;
  cursor: pointer;
  transition: color 0.3s;
}

.bill-number:hover {
  color: #06b6d4;
  text-decoration: underline;
}

.transaction-code {
  font-size: 0.75rem;
  color: #9ca3af;
  font-family: monospace;
}

.description-text {
  display: block;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-info-cell {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.user-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: linear-gradient(135deg, #7c3aed 0%, #a855f7 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 600;
}

.user-name {
  font-weight: 500;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.location-info {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}

.location-main {
  font-weight: 500;
}

.location-sub {
  font-size: 0.75rem;
  color: #9ca3af;
}

.agent-name {
  font-weight: 500;
}

.amount-value {
  font-weight: 700;
  color: #10b981;
  font-size: 0.9375rem;
}

.invoice-amount {
  font-weight: 600;
  color: #6b7280;
  font-size: 0.9375rem;
}

.transaction-amount {
  font-weight: 600;
  color: #3b82f6;
  font-size: 0.9375rem;
}

.payment-method {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.625rem;
  border-radius: 4px;
  font-size: 0.625rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.payment-mpesa {
  background: rgba(16, 185, 129, 0.1);
  color: #10b981;
}

.payment-bank {
  background: rgba(59, 130, 246, 0.1);
  color: #3b82f6;
}

.payment-cash {
  background: rgba(245, 158, 11, 0.1);
  color: #f59e0b;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.625rem;
  border-radius: 4px;
  font-size: 0.625rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.status-badge i {
  font-size: 0.5rem;
}

.status-paid {
  background: rgba(16, 185, 129, 0.1);
  color: #10b981;
}

.status-unpaid {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}

.date-text {
  font-weight: 500;
  color: #6b7280;
}

.action-buttons {
  display: flex;
  gap: 0.25rem;
  justify-content: center;
}

.btn-icon {
  width: 28px;
  height: 28px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  font-size: 0.875rem;
}

/* Loading & Empty States */
.loading-state,
.empty-state {
  padding: 4rem 2rem;
  text-align: center;
}

.empty-icon {
  font-size: 4rem;
  color: #e5e7eb;
  margin-bottom: 1rem;
}

.loading-state h4,
.empty-state h3 {
  color: #374151;
  margin-bottom: 0.5rem;
}

.loading-state p,
.empty-state p {
  color: #6b7280;
  font-size: 0.875rem;
}

/* Pagination */
.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1rem 1.25rem;
  background: #f9fafb;
}

.pagination-info {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 0.875rem;
  color: #6b7280;
}

.page-size-select {
  width: auto;
  height: 32px;
  padding: 0 2rem 0 0.75rem;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 0.875rem;
}

.pagination {
  margin: 0;
  display: flex;
  gap: 0.25rem;
}

.page-item .page-link {
  padding: 0.375rem 0.625rem;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  color: #6b7280;
  font-size: 0.875rem;
  cursor: pointer;
  background: white;
  transition: all 0.2s;
  min-width: 32px;
  text-align: center;
}

.page-item .page-link:hover {
  background: #0891b2;
  color: white;
  border-color: #0891b2;
}

.page-item.active .page-link {
  background: #0891b2;
  color: white;
  border-color: #0891b2;
}

.page-item.disabled .page-link {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

/* Modal Styles */
.modal-content {
  border: none;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.modal-header {
  background: linear-gradient(135deg, #7c3aed 0%, #a855f7 100%);
  color: white;
  border: none;
  border-radius: 12px 12px 0 0;
  padding: 1.25rem 1.5rem;
}

.modal-title {
  font-weight: 600;
  display: flex;
  align-items: center;
}

.modal-title i {
  margin-right: 0.5rem;
}

.btn-close {
  color: white;
  opacity: 0.8;
  filter: brightness(0) invert(1);
}

.btn-close:hover {
  opacity: 1;
}

.modal-body {
  padding: 1.5rem;
}

.bill-detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e5e7eb;
  margin-bottom: 1.5rem;
}

.bill-number-large {
  font-size: 1.5rem;
  color: #7c3aed;
  margin-bottom: 0.25rem;
}

.bill-meta {
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0;
}

.status-badge-large {
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.875rem;
}

.status-badge-large.success {
  background: rgba(16, 185, 129, 0.1);
  color: #10b981;
}

.status-badge-large.danger {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}

.bill-detail-customer {
  margin-bottom: 1.5rem;
}

.section-title {
  font-size: 0.875rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #6b7280;
  margin-bottom: 1rem;
  letter-spacing: 0.5px;
}

.customer-info {
  background: #f9fafb;
  padding: 1rem;
  border-radius: 8px;
}

.info-item {
  display: flex;
  margin-bottom: 0.5rem;
}

.info-item:last-child {
  margin-bottom: 0;
}

.info-item .info-label {
  font-weight: 600;
  margin-right: 0.5rem;
  min-width: 100px;
  color: #6b7280;
}

.info-item .info-value {
  color: #374151;
}

.table-modal {
  margin-bottom: 0;
}

.table-modal thead {
  background: #f9fafb;
}

.table-modal thead th {
  padding: 0.75rem;
  font-size: 0.8125rem;
  font-weight: 600;
  text-transform: uppercase;
  color: #6b7280;
  border: none;
}

.table-modal tbody td {
  padding: 0.75rem;
  font-size: 0.875rem;
  border-top: 1px solid #e5e7eb;
}

.table-total {
  background: #f9fafb;
}

.table-total td {
  padding: 1rem 0.75rem;
  border-top: 2px solid #e5e7eb;
}

.modal-footer {
  background: #f9fafb;
  border-top: 1px solid #e5e7eb;
  border-radius: 0 0 12px 12px;
  padding: 1rem 1.5rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .header-content-wrapper {
    flex-direction: column;
    align-items: flex-start;
  }

  .header-right {
    width: 100%;
    justify-content: space-between;
  }

  .filter-controls-wrapper {
    flex-direction: column;
    width: 100%;
  }

  .filter-item,
  .date-range-item {
    width: 100%;
  }

  .pagination-wrapper {
    flex-direction: column;
  }

  .pagination-info {
    width: 100%;
    justify-content: space-between;
  }
}
</style>